<template>
  <div>
    <tabComponent></tabComponent>
    <getDataContent />
  </div>
</template>
<script>
import tabComponent from "./../tabComponent/tabComponent";
import getDataContent from "./../board/getDataContent.vue";

import { mapGetters } from "vuex";
export default {
  components: {
    tabComponent,
    getDataContent
  },
  mounted() {
    this.$store.dispatch("general/getTab","board");
  },
  methods: {
    changeTab() {
      console.log(this.tab);
    }
  },
  computed: {
    ...mapGetters({
      tab: "general/tab",
     
    })
  }
};
</script>
<style lang="scss"></style>
